export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }

  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('PRESS_MODULE_SHOULDNT_BE_ACTIVATED') === 0) {
      messages.push({
        message: 'general.popUpChangementCommercial.errors.modullePresseActif',
      });
    }
    if (message.indexOf('BATCH_CHANGEMENT_COMMERCIAL_NO_ID_SELECTED') === 0) {
      messages.push({
        message: 'general.popUpChangementCommercial.errors.aucunCommercial',
      });
    }
    if (message.indexOf('COMMERCIAL_NOT_EXIST') === 0) {
      messages.push({
        message: 'general.popUpChangementCommercial.errors.commercialNotExist',
      });
    }
  });
}
